import {hasLocalStorage} from "./hasLocalStorage";
import {nodeListToArray} from "./nodeListToArray";

export function setupTabs() {
    function setTab(tabContainer, activeIndex) {
        const tabListItems = nodeListToArray(tabContainer.querySelector('.tabs').querySelectorAll('li'));
        const tabsAll = nodeListToArray(tabContainer.querySelectorAll('.tab'));
        const tabs = [];

        for (const possible of tabsAll) {
            if (possible.parentNode === tabContainer) {
                tabs.push(possible);
            }
        }
        for (let tabIndex = 0; tabIndex < tabListItems.length; tabIndex++) {
            const tabListItem = tabListItems[tabIndex];
            const tab = tabs[tabIndex];
            tabListItem.classList.toggle('is-active', tabIndex === activeIndex);
            tab.classList.toggle('is-hidden', tabIndex !== activeIndex);
        }
    }

    const tabContainers = nodeListToArray(document.querySelectorAll('.tabs-container:not([data-tabsetup="yes"])'));

    for (let tabContainerIndex = 0; tabContainerIndex < tabContainers.length; tabContainerIndex++) {
        const tabContainer = tabContainers[tabContainerIndex];

        tabContainer.setAttribute("data-tabsetup", 'yes'); // Only setup once

        const tabListItems = nodeListToArray(tabContainer.querySelector('.tabs').querySelectorAll('li'));

        const tabGroupLabel = tabContainer.getAttribute('data-tab-group');
        const activeTab = hasLocalStorage() ? localStorage.getItem('Tab Group/' + tabGroupLabel) : null;

        let defaultActiveIndex = 0;
        let localStorageActiveIndex = null;
        for (let tabListIndex = 0; tabListIndex < tabListItems.length; tabListIndex++) {
            const tabListItem = tabListItems[tabListIndex];
            if (tabListItem.classList.contains('is-active')) {
                defaultActiveIndex = tabListIndex;
            }

            const tabLabel = tabListItem.getAttribute('data-tab');
            if (activeTab !== null && activeTab === tabLabel) {
                localStorageActiveIndex = tabListIndex;
            }

            tabListItem.querySelector('a').addEventListener('click', function () {
                setTab(tabContainer, tabListIndex);

                if (hasLocalStorage()) {
                    localStorage.setItem('Tab Group/' + tabGroupLabel, tabLabel);
                }

                gtag('event', 'tab-action', {
                    'event_category': 'switch-tab',
                    'event_label': tabGroupLabel + '/' + tabLabel
                });
            });
        }

        const activeIndex = localStorageActiveIndex ?? defaultActiveIndex;
        setTab(tabContainer, activeIndex);
    }
}
